import FundRequestDetailsContainer from "./FundRequestDetailsContainer";

export default FundRequestDetailsContainer;
